(() => {
  if (window.ffcTransducerNavLoaded) return;
  window.ffcTransducerNavLoaded = true;
  const connectPanel = () => {
    document.querySelectorAll('.ffc-nav-desktop [data-ffc-panel-owner][open]').forEach(detail => {
      const panel = detail.querySelector(':scope > .ffc-nav-panel, :scope > .ffc-nav-course-panel');
      const trigger = detail.querySelector(':scope > summary');
      const parent = panel.offsetParent;
      if (!parent) return;
      const top = trigger.getBoundingClientRect().bottom - parent.getBoundingClientRect().top - parent.clientTop + parent.scrollTop;
      panel.style.top = `${top}px`;
      const viewportLeft = Math.max(32, Math.min(trigger.getBoundingClientRect().left - 8, document.documentElement.clientWidth - panel.offsetWidth - 32));
      panel.style.left = `${viewportLeft - parent.getBoundingClientRect().left - parent.clientLeft + parent.scrollLeft}px`;
      panel.style.transform = 'none';
    });
  };
  window.addEventListener('resize', connectPanel);
  if (document.fonts) document.fonts.ready.then(connectPanel);
  const init = (root = document) => {
    root.querySelectorAll('[data-ffc-body]').forEach(body => {
      if (body.dataset.ffcReady) return;
      body.dataset.ffcReady = 'true';
      const choices = [...body.querySelectorAll('[data-ffc-choice]')];
      const helps = [...body.querySelectorAll('[data-ffc-help]')];
      const courseChoice = body.querySelector('[data-ffc-course-choice]');
      const identification = body.querySelector('[data-ffc-identification-help]');
      const layout = body.querySelector('.ffc-nav-layout');
      const updateLayoutHeight = () => {
        if (!layout || !body.classList.contains('ffc-nav-body--desktop')) return;
        const openChoice = choices.find(choice => choice.open);
        const activePanel = identification && identification.open
          ? identification.querySelector('.ffc-nav-identification-panel')
          : openChoice && openChoice.querySelector('.ffc-nav-model-panel, .ffc-nav-universal-panel');
        if (!activePanel) {
          layout.style.removeProperty('--ffc-active-layout-height');
          return;
        }
        const panelTop = activePanel.getBoundingClientRect().top - layout.getBoundingClientRect().top;
        const requiredHeight = Math.ceil(panelTop + activePanel.scrollHeight + 24);
        layout.style.setProperty('--ffc-active-layout-height', `${requiredHeight}px`);
      };
      const panelObserver = new ResizeObserver(() => requestAnimationFrame(updateLayoutHeight));
      body.querySelectorAll('.ffc-nav-model-panel, .ffc-nav-universal-panel, .ffc-nav-identification-panel').forEach(panel => panelObserver.observe(panel));
      requestAnimationFrame(updateLayoutHeight);
      let lastChoice = choices.find(choice => choice.open) || choices[0];
      const closeHelps = except => helps.forEach(help => { if (help !== except) help.open = false; });
      const restoreChoice = () => {
        if (body.classList.contains('ffc-nav-body--desktop') && !choices.some(choice => choice.open) && lastChoice) lastChoice.open = true;
      };
      choices.forEach(choice => {
        const summary = choice.querySelector(':scope > summary');
        summary.setAttribute('aria-expanded', String(choice.open));
        summary.addEventListener('click', event => {
          if (choice === courseChoice) choice.classList.remove('ffc-nav-universal-choice--fallback');
          if (!choice.open) {
            lastChoice = choice;
            closeHelps();
            choices.forEach(other => { if (other !== choice) other.open = false; });
          } else if (body.classList.contains('ffc-nav-body--desktop')) {
            event.preventDefault();
          }
        });
        choice.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(choice.open));
          requestAnimationFrame(updateLayoutHeight);
        });
      });
      helps.forEach(help => {
        const summary = help.querySelector(':scope > summary');
        help.addEventListener('toggle', () => requestAnimationFrame(updateLayoutHeight));
        summary.addEventListener('click', () => {
          if (!help.open) {
            const identificationWasOpen = identification && identification.open && help !== identification;
            closeHelps(help);
            if (help === identification) {
              lastChoice = choices.find(choice => choice.open) || lastChoice;
              choices.forEach(choice => { choice.open = false; });
            } else if (identificationWasOpen) {
              restoreChoice();
            }
          } else if (help === identification) {
            requestAnimationFrame(restoreChoice);
          }
        });
      });
      const identificationClose = body.querySelector('[data-ffc-identification-close]');
      if (identification && identificationClose) {
        identificationClose.addEventListener('click', () => {
          identification.open = false;
          restoreChoice();
          const summary = identification.querySelector(':scope > summary');
          summary.focus();
          if (body.classList.contains('ffc-nav-body--mobile')) requestAnimationFrame(() => summary.scrollIntoView({block: 'nearest'}));
        });
      }
      const courseTrigger = body.querySelector('[data-ffc-course-open-trigger]');
      if (courseTrigger && courseChoice) {
        const updateCourseTrigger = () => courseTrigger.setAttribute('aria-expanded', String(courseChoice.open));
        courseChoice.addEventListener('toggle', updateCourseTrigger);
        courseTrigger.addEventListener('click', event => {
          event.preventDefault();
          closeHelps();
          choices.forEach(choice => { choice.open = choice === courseChoice; });
          courseChoice.classList.add('ffc-nav-universal-choice--fallback');
          lastChoice = courseChoice;
          updateCourseTrigger();
          if (body.classList.contains('ffc-nav-body--mobile')) {
            requestAnimationFrame(() => courseChoice.scrollIntoView({block: 'start'}));
          }
        });
        updateCourseTrigger();
      }
    });
    root.querySelectorAll('.ffc-nav-desktop details,.ffc-nav-mobile details').forEach(detail => {
      if (detail.dataset.ffcDisclosureReady) return;
      detail.dataset.ffcDisclosureReady = 'true';
      const summary = detail.querySelector(':scope > summary');
      summary.setAttribute('aria-expanded', String(detail.open));
      detail.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(detail.open));
        connectPanel();
      });
      summary.addEventListener('click', () => {
        if (!detail.open && detail.hasAttribute('data-ffc-help')) {
          const mobile = detail.closest('.ffc-nav-mobile');
          if (mobile) mobile.querySelectorAll('[data-ffc-help]').forEach(other => { if (other !== detail) other.open = false; });
        }
        if (!detail.open && detail.hasAttribute('data-ffc-top')) {
          detail.closest('.ffc-nav-desktop,.ffc-nav-mobile').querySelectorAll('[data-ffc-top]').forEach(other => { if (other !== detail) other.open = false; });
        }
      });
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('.ffc-nav-desktop').forEach(nav => {
      if (!nav.contains(event.target)) nav.querySelectorAll('[data-ffc-top]').forEach(detail => { detail.open = false; });
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.ffc-nav-desktop').forEach(nav => {
      if (!nav.contains(event.target)) nav.querySelectorAll('[data-ffc-top]').forEach(detail => { detail.open = false; });
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const nav = event.target.closest('.ffc-nav-desktop');
    if (!nav) return;
    const opened = [...nav.querySelectorAll('[data-ffc-top][open]')];
    if (opened.length) {
      event.preventDefault();
      opened.forEach(detail => { detail.open = false; });
      opened[0].querySelector('summary').focus();
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
